import React from 'react';
import { DateRange } from 'react-day-picker';
import { UseControllerProps } from 'react-hook-form/dist/types/controller';

import { FormGroupEssentialProps } from '../../../components';
import {
  RangePickerInput,
  RangePickerProps,
} from '../../../components/RangePickerInput/ui/RangePickerInput/RangePickerInput';

import { ConnectedComponentProps, ConnectHelper } from './ConnectHelper';

export type RangeDayPickerInputProps = RangePickerProps &
  FormGroupEssentialProps & {
    rules?: UseControllerProps['rules'];
  };

const RangeDayPickerInner = ({
  componentProps,
  controllerField,
}: ConnectedComponentProps<
  RangePickerProps & {
    name: string;
  }
>) => (
  <RangePickerInput
    {...controllerField}
    {...componentProps}
    /** Since we don't have initial value to determine if field is connected we should explicitly provide flag if field is connected */
    isRHFConnected={Boolean(controllerField)}
    onChange={(value) => {
      controllerField?.onChange(value);

      componentProps.onChange?.(value);
    }}
    onBlur={(e) => {
      controllerField?.onBlur();

      componentProps.onBlur?.(e);
    }}
  />
);

export const ConnectedRangePickerInput = (props: RangeDayPickerInputProps & { name: string }) => (
  <ConnectHelper<RangeDayPickerInputProps & { name: string }, DateRange>
    {...props}
    RenderComponent={RangeDayPickerInner}
  />
);
